import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Location } from '@angular/common';
import { pathUrl } from '../../configs';
import { Router } from '@angular/router';
import { HttpService } from '@web-di-ld/apps/http';

export interface JavascriptCallback {
  exitFullScreen(data: any): any;
}

declare const LoanWeb: JavascriptCallback;
declare const window: any;
declare const webkit: any;
@Injectable()
export class DialogErrorHandlerService
  implements ErrorHandler, HttpInterceptor {
  openDialog = false;
  dialogMessageCode = 6;
  onAcceptDialog = () => {};
  errorCodeTemp: number = 0;

  constructor(
    private location: Location,
    private router: Router,
    private httpService: HttpService
  ) {}

  handleError(error: any): void {
    console.error(error);
    this.openDialog = true;
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error(error);
        this.errorCodeTemp = error.status;
        /**
         * custom ErrorCode here!
         */
        if (error && this.checkIgnoreError(error, request))
          this.handleError(error);

        return throwError(error);
      })
    );
  }

  checkIgnoreError(error: HttpErrorResponse, request: HttpRequest<any>) {
    if (
      error.url?.includes('/api/offers/v1/loan-offers') &&
      request.method === 'GET'
    ) {
      return false;
    }

    return true;
  }

  closeDialog() {
    this.openDialog = false;
    const path = this.location.path();
    // const accessToken:string = '?accessToken='+await this.httpService.token$.toPromise();

    const strPath = path.includes('?')
      ? path.substring(0, path.lastIndexOf('?'))
      : path.substring(0, path.length);
    if (this.errorCodeTemp === 401) {
      this.errorCodeTemp = 0;
      const ua = navigator.userAgent.toLowerCase();
      const isAndroid = ua.indexOf('android') > -1;
      try {
        if (isAndroid) {
          let android = LoanWeb;
          console.log('isAndroid');
          android.exitFullScreen(null);
        } else {
          window.webkit.messageHandlers.exitFullScreen.postMessage(null);
        }
      } catch (error) {
        console.log('isWeb');
      }
    } else if (!strPath || strPath === pathUrl.loanProductShelf) {
      const ua = navigator.userAgent.toLowerCase();
      const isAndroid = ua.indexOf('android') > -1;
      try {
        if (isAndroid) {
          let android = LoanWeb;
          console.log('isAndroid');
          android.exitFullScreen(null);
        } else {
          window.webkit.messageHandlers.exitFullScreen.postMessage(null);
        }
      } catch (error) {
        console.log('isWeb');
      }
      // window.location.reload();
    } else {
      this.location.back();
    }

    this.onAcceptDialog();
    this.onAcceptDialog = () => {};
  }
}
